export default {
    data : [
        {
            id:'data_kategori', type:'info', label:'Master Kategori', hidden: 'no',
            child: [
                {id:'id', content_text: 'text', type:'text', label:'Id', hidden: 'yes'},
                {id:'telegram_id', content_text: 'text', type:'text', label:'Id Telegram', hidden: 'no'},
                {id:'nama', content_text: 'text', type:'text', label:'Nama User', hidden: 'no'},
                { 
                    id:'status', content_text: 'text', 
                    type:'radio_button', 
                    label:'Status', 
                    hidden: 'no', 
                    property:['Aktif', 'Non-Aktif'], 
                    value:['AKTIF', 'NON-AKTIF']
                },
            ]

        }
    ]
}